export function rankedRoutePickerEntities(entities, { maxItems = 6, minScore = 0.25 } = {}) {
  const clean = Array.isArray(entities) ? entities.filter(Boolean) : [];
  const ranked = [...clean].sort((left, right) => {
    const leftScore = Number(left?.score || 0);
    const rightScore = Number(right?.score || 0);
    if (rightScore !== leftScore) return rightScore - leftScore;
    return String(left?.display_name || left?.name || "").localeCompare(
      String(right?.display_name || right?.name || ""),
    );
  });
  const aboveThreshold = ranked.filter((entity) => Number(entity?.score || 0) >= minScore);
  return (aboveThreshold.length ? aboveThreshold : ranked).slice(0, maxItems);
}

export function resolutionFromRouteAlternatives(alternatives = []) {
  const entities = {
    agents: [],
    tools: [],
    workflows: [],
    knowledge: [],
  };
  (Array.isArray(alternatives) ? alternatives : []).filter(Boolean).forEach((entity) => {
    const type = String(entity?.type || "").toLowerCase();
    if (type === "tool") {
      entities.tools.push(entity);
    } else if (type === "workflow") {
      entities.workflows.push(entity);
    } else if (type === "knowledge") {
      entities.knowledge.push(entity);
    } else {
      entities.agents.push({ ...entity, type: entity?.type || "agent" });
    }
  });
  return { entities };
}

export function shouldShowRoutePicker({ routePickerOpen, entityCount }) {
  return Boolean(routePickerOpen && Number(entityCount || 0) > 0);
}

export function routePickerTitle() {
  return "Choose a different route";
}
